<rcp-button [disabled]="disabled" [active]="active">
  @if (icon) {
    <fa-icon [icon]="icon"></fa-icon>
  }
  <span>
    <ng-content></ng-content>
  </span>
  <fa-icon
    class="icon-style-angle"
    [class.rotate-icon]="iconRightRotate"
    [class.rotate]="active"
    [icon]="faAngleDown"
  ></fa-icon>
</rcp-button>
